

export const APPLICATION_CONTAINER_ID = 'AppContainer';
export const DEFAULT_THEME = "dark";

// --------------
// Named routes
// --------------
export const PATH_SHOPPING_CART = 'shopping-cart';
export const PATH_COURSE = 'course';
export const PATH_LOCATION = 'location';
export const PATH_GIFT_CARD = 'giftcertificate';
export const PATH_CART = 'cart';
export const PATH_SUBSCRIBE = 'subscribe';

export const NEMO_URL_PRODUCTION = "https://www.audi.com.au/au/web/en/audi-driving-experience.html";
export const NEMO_URL_STAGING = "https://cms1-author.audi.com/au/web/en/Audi_driving_experience_02/Courses.html";

export const TERMS_VOUCHER_URL = "https://cdn04.audiproduction.com.au/media/djzhiavs/ade_-_voucher_tcs.pdf";

// Action types
export const DISABLE_NAV = 'DISABLE_NAV';
export const SET_NAV_INDEX = 'SET_NAV_INDEX';
export const SET_SHOPPING_CART = 'SET_SHOPPING_CART';
export const SET_FINAL_CART = 'SET_FINAL_CART';
export const SET_ALERT_MSG = 'SET_ALERT_MSG';
export const SET_HERO = 'SET_HERO';
export const SET_DONATION = 'SET_DONATION';
export const SET_DONATION_ERROR = 'SET_DONATION_ERROR';

// Nav Index
export const SHOPPING_NAV_INDEX = 0;
export const PERSONAL_NAV_INDEX = 1;
export const PAYMENT_NAV_INDEX = 2;
export const CONFIRMATION_NAV_INDEX = 3;

// Cart
export const ADD_TO_CART = 'ADD_TO_CART';
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';

// shoppingCart item
export const ITEM_GIFT_CARD = 'GiftCard';
export const ITEM_EXPERIENCE = 'ExperienceBooking';

export const GIFT_CARD_NAME = "Gift Voucher";
export const GIFT_CARD_AMOUNTS = [1, 250, 500, 800, 1450, 1995, 3500];

// Alert messages
export const ERR_MSG_NO_COURSES = 'Sorry, the requested Experience is not available';
export const ERR_MSG_NO_LOCATIONS = 'Sorry, the requested Circuit is not available';

export const FEATURE_TOGGLE = {
    DONATION: true,
    WAITLIST: true,
    MAINTENANCE: false,
    MAINTENANCE_SF: false,
    MAINTENANCE_NOTE: "<p>We are undergoing website maintenance until week commencing 30 August. If you would like to make an Audi driving experience booking please:</p><ul><li>Email us at <a href='mailto:customerassistance@audi-info.com.au'>customerassistance@audi-info.com.au</a></li><li>Call us on <a href='tel:1300557405'>1300 557 405</a></li></ul>",
    PRE_MAINTENANCE_NOTE: false //"<p>ADE will be undergoing maintenance soon.</p>"
};

// IDs for programs that don't require a license
// this is a hack for the F1 experience
export const noLicense = {
  "local": [1035],
  "development": [1035],
  "staging": [1026],
  "production": [1037, 1038, 1039]
};
